import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { TokenService } from '../../services/token/token.service';

export const guestGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  // If user is authenticated - redirect to the default Games tab.
  if (tokenService.isAuthenticated) {
    return router.parseUrl('/tabs/games');
  }

  // Guest can access this route
  return true;
};
